const PBM_PARTNERS_LIST_NAMESPACE = 'jbp-pbm-partners-list'

export const PARTNER_SCOPE_TRANSLATION_KEYS = {
  title: `${PBM_PARTNERS_LIST_NAMESPACE}--title`, // unneeded
  descriptionMessage: `${PBM_PARTNERS_LIST_NAMESPACE}--description-message`,
  partnersCount: `${PBM_PARTNERS_LIST_NAMESPACE}--partners-count`,
  addPartner: `${PBM_PARTNERS_LIST_NAMESPACE}--add-partner`,
  notMyPartner: `${PBM_PARTNERS_LIST_NAMESPACE}--not-my-partner`,
  removeRequest: `${PBM_PARTNERS_LIST_NAMESPACE}--remove-request`,
  addRequest: `${PBM_PARTNERS_LIST_NAMESPACE}--add-request`,
  updateRequest: `${PBM_PARTNERS_LIST_NAMESPACE}--update-request`,
  noPartners: `${PBM_PARTNERS_LIST_NAMESPACE}--no-partners`,
  filterOnlyRequest: `${PBM_PARTNERS_LIST_NAMESPACE}--filter-only-request`,
  onlyHeadquarters: `${PBM_PARTNERS_LIST_NAMESPACE}--only-headquarters`,
  onlyTopPartners: `${PBM_PARTNERS_LIST_NAMESPACE}--only-top-partners`,
  addActionsCountTooltip: `${PBM_PARTNERS_LIST_NAMESPACE}--add-actions-count-tooltip`,
  removeActionsCountTooltip: `${PBM_PARTNERS_LIST_NAMESPACE}--remove-actions-count-tooltip`,
  updateActionsCountTooltip: `${PBM_PARTNERS_LIST_NAMESPACE}--update-actions-count-tooltip`,
  partnerCardActions: {
    addPartner: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--add-partner`,
    notMyPartner: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--not-my-partner`,
    edit: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--edit`,
    removeRequest: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--remove-request`,
    dataDiffersTooltip: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--data-differs-tooltip`,
    roleDiscrepancy: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--discrepancy-role`,
    buDiscrepancy: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--discrepancy-bu`,
    allDiscrepancy: `${PBM_PARTNERS_LIST_NAMESPACE}--actions--discrepancy-bu-and-role`,
  },
}

const BINDINGS_MANAGEMENT_DISCLAIMER_NAMESPACE = `${PBM_PARTNERS_LIST_NAMESPACE}--bindings-disclaimer`

export const BINDINGS_MANAGEMENT_DISCLAIMER_TRANSLATION_KEYS = {
  title: `${BINDINGS_MANAGEMENT_DISCLAIMER_NAMESPACE}--title`,
  bulletList: `${BINDINGS_MANAGEMENT_DISCLAIMER_NAMESPACE}--bullet-list-options`,
  endMessage: `${BINDINGS_MANAGEMENT_DISCLAIMER_NAMESPACE}--end-message`,
  understood: `${BINDINGS_MANAGEMENT_DISCLAIMER_NAMESPACE}--understood`,
  expand: `${BINDINGS_MANAGEMENT_DISCLAIMER_NAMESPACE}--expand`,
}

export const WELCOME_FLOW_NAMESPACE = 'jbp-welcome-flow'

export const WELCOME_FLOW_TRANSLATION_KEYS = {
  dialogTitle: `${WELCOME_FLOW_NAMESPACE}--dialog-title`,

  welcomeScreen: {
    greetings: `${WELCOME_FLOW_NAMESPACE}--welcome-screen--greetings`,
    infoMessage: `${WELCOME_FLOW_NAMESPACE}--welcome-screen--infoMessage`,
    bulletList: `${WELCOME_FLOW_NAMESPACE}--welcome-screen--list`,
  },

  welcomeFlowForm: {
    title: `${WELCOME_FLOW_NAMESPACE}--form--title`,
    rtmField: `${WELCOME_FLOW_NAMESPACE}--form--rtm-field`,
    managerField: `${WELCOME_FLOW_NAMESPACE}--form--manager-field`,
    roleField: `${WELCOME_FLOW_NAMESPACE}--form--role-field`,
    buField: `${WELCOME_FLOW_NAMESPACE}--form--bu-field`,

    roleAndReporting: {
      title: `${WELCOME_FLOW_NAMESPACE}--form--role-and-reporting--title`,
      description: `${WELCOME_FLOW_NAMESPACE}--form--role-and-reporting--description`,
    },

    rtmAndBu: {
      title: `${WELCOME_FLOW_NAMESPACE}--form--rtm-and-bu--title`,
      description: `${WELCOME_FLOW_NAMESPACE}--form--rtm-and-bu--description`,
    },
  },

  partnerScopeInfo: {
    title: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--title`,
    titleAddon: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--title-addon`,
    statsLabel: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--stats-label`,
    statsCountries: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--countries-label`,
    statsRegion: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--region-label`,
    infoMessage: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--detailed-message`,
    reviewList: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--review-list`,

    missingAssignments: {
      title: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--missing-assignments--title`,
      description: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--missing-assignments--description`,
      emptyTitle: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--missing-assignments--empty-title`,
      emptyMessage: `${WELCOME_FLOW_NAMESPACE}--partner-scope-info--missing-assignments--empty-message`,
    },
    missingPartner: {
      requestWillNotBeSent: `${WELCOME_FLOW_NAMESPACE}--missing-partner--request-will-not-be-sent`,
    },
  },

  controls: {
    disclaimer: `${WELCOME_FLOW_NAMESPACE}--controls--disclaimer`,
    startReview: `${WELCOME_FLOW_NAMESPACE}--controls--start-review`,
    later: `${WELCOME_FLOW_NAMESPACE}--controls--later`,
    goBack: `${WELCOME_FLOW_NAMESPACE}--controls--go-back`,
    goNext: `${WELCOME_FLOW_NAMESPACE}--controls--go-next`,
    saveAndGoNext: `${WELCOME_FLOW_NAMESPACE}--controls--save-and-go-next`,
    missingPartnersCreateRequests: `${WELCOME_FLOW_NAMESPACE}--controls--missing-partners--create-requests`,
    missingPartnersSaveAndReview: `${WELCOME_FLOW_NAMESPACE}--controls--missing-partners--save-and-review-my-partners`,
    missingPartnersReview: `${WELCOME_FLOW_NAMESPACE}--controls--missing-partners--review-my-partners`,
    saveAndDone: `${WELCOME_FLOW_NAMESPACE}--controls--save-and-done`,
  },

  completion: {
    title: `${WELCOME_FLOW_NAMESPACE}--completion--title`,
    message: `${WELCOME_FLOW_NAMESPACE}--completion--message`,
  },

  bindingsSummary: {
    prefilledDataLabel: `${WELCOME_FLOW_NAMESPACE}--bindings-summary--prefilled-data-label`,
    regionLabel: `${WELCOME_FLOW_NAMESPACE}--bindings-summary--region-label`,
    countriesLabel: `${WELCOME_FLOW_NAMESPACE}--bindings-summary--countries-label`,
    partnersTotalLabel: `${WELCOME_FLOW_NAMESPACE}--bindings-summary--partners-total-label`,
    roleLabel: `${WELCOME_FLOW_NAMESPACE}--bindings-summary--role-label`,
    buLabel: `${WELCOME_FLOW_NAMESPACE}--bindings-summary--bu-label`,
  },
}
